import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Switching from apache to nginx is a dream",
  "description": "",
  "published": "2009-12-14T00:00:00.000Z",
  "redirect_from": ["/blog/switching-from-apache-to-nginx-is-a-dream/swizec/978"],
  "categories": "Apache, intrigues, life, Server, Uncategorized, WWW",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:My_Opera_Server.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2009/12/300px-My_Opera_Server.jpg",
              "alt": "A server used for the My Home",
              "title": "A server used for the My Home"
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:My_Opera_Server.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`Since as far back as my memory goes I've been using `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Apache_HTTP_Server",
        "title": "Apache HTTP Server"
      }}>{`Apache`}</a>{` for my main, primary, and absolutely only `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Web_server",
        "title": "Web server"
      }}>{`webserver`}</a>{`. It was the workhorse of everything from dev environments to production machines serving tens of pages.`}</p>
    <p>{`But throughout this love affair there was one constant - I had to change things.`}</p>
    <p>{`This isn't bad. Of course when you first start using `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Rewrite_engine",
        "title": "Rewrite engine"
      }}>{`mod_rewrite`}</a>{` you're going to have to change things and naturally adding a new website on a new domain means changing a few things. No problem here, all natural.`}</p>
    <p>{`But still, there was a certain feeling that rose up in me like a mad urge, a feeling of endless power and proportion, a feeling like, hey, I've had sex with this woman a few times, and I quite like it, but there's something missing something isn't quite right, why can't I watch a good movie instead of having this sex thing?`}</p>
    <p>{`That's right, it was the`}<strong parentName="p">{` Sense of Impending Doom. `}</strong>{`Because you see dearies, whenever you have to make a small change in the apache configs a small part of your soul dies. You know it's supposed to be a small change, you know it's supposed to be effortless, but despite having done this countless times, you still waste an hour making everything work.`}</p>
    <p>{`This Saturday I finally stomped my foot like a little school girl and said ENOUGH! Then I installed nginx.`}</p>
    <p>{`It was a bit daunting at first and I may still not know how to pronounce the name, but I love it. The damn thing is sooper fast and when I had to add a config for a new site ... hah! Took three lines of code, sure it was only for serving static files, but the same thing in apache takes a separate file, then a vhost, then blahlbah. Fuck you!`}</p>
    <p>{`Here's an example, come on, would you see anything so sleek and awesome under Apache? Ever?`}</p>
    <pre><code parentName="pre" {...{}}>{`server {
                listen localhost:80;
                server_name lestat;

                root /var/www;
                index <a class="zem_slink freebase/en/webserver_directory_index" title="Webserver directory index" rel="wikipedia" href="http://en.wikipedia.org/wiki/Webserver_directory_index">index.html</a>;
        }
`}</code></pre>
    <p>{`Now obviously I don't know how to do fancy rewrites and stuff yet, but from what I've seen so far, I think nginx and Swizec are a match made in heaven for the foreseeable future.`}</p>
    <p>{`So there you go @`}<a parentName="p" {...{
        "href": "http://twitter.com/robertbasic",
        "title": "Robert Basic"
      }}>{`robertbasic`}</a>{`, @genom, @loudandwicked, @jaspertandy ... a blog post about the change.`}</p>
    <p>{`PS: about versatility and such that @genom mentioned, I haven't a bloody clue (yet)`}</p>
    <p>{`PS2: apologies to everyone I mentioned in the post and didn't link to, Zemanta didn't suggest the links and I'm too lazy to do them manugally.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/03a978c3-1d04-49d7-a49a-ad4251933077/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=03a978c3-1d04-49d7-a49a-ad4251933077",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      